<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="5" width="22" height="20" rx="3" stroke="white" stroke-width="1.8" fill="none"/>
  <line x1="3" y1="11" x2="25" y2="11" stroke="white" stroke-width="1.8"/>
  <line x1="9" y1="5" x2="9" y2="2" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="19" y1="5" x2="19" y2="2" stroke="white" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M17 17.5L14 20.5L12 18.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
